var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3327.868852459016,
    height: 1721.311475409836,
    viewBox: "0 0 3327.868852459016 1721.311475409836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(16.39344262295082) translate(10, 10)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1117"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1118",
    featureKey: "rootContainer",
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "nonzero",
    d: "             M0,0             H183             V85             H0,0             z             M4,4             v77             h175             v-77             z     "
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1119",
    featureKey: "nameFeature-0",
    transform: "matrix(1.9817153376711578,0,0,1.9817153376711578,14.542673434866408,-8.59155031366475)",
    fill: "#fe6513"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2 40 l0 -18.12 l-4.96 2.72 l0 -8.72 l6.52 -4.48 l9.08 0 l0 28.6 l-10.64 0 z M22.346 40 l0 -28.6 l21.36 0 l0 8.12 l-10.76 0 l0 2.44 l8.48 0 l0 7.36 l-8.48 0 l0 2.56 l11.36 0 l0 8.12 l-21.96 0 z M55.89200000000001 40 l-9.36 -28.6 l11.6 0 l4.4 17.44 l4.44 -17.44 l9.96 0 l-9.08 28.6 l-11.96 0 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9fa6541f743c07aa3c845a631fc7eee5.svg";
export { ForwardRef as ReactComponent };